export default __webpack_public_path__ + "static/media/menu-icon-dark.93552eb6.svg";